import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({ providedIn: "root" })
export class LoadingIndicationService {
  constructor() {}

  private _activeRequestUrls$ = new BehaviorSubject<string[]>([]);
  activeRequestUrls$ = this._activeRequestUrls$.asObservable();

  show(url: string) {
    const update = [...this._activeRequestUrls$.value, url];
    this._activeRequestUrls$.next(update);
  }

  hide(url: string) {
    const update = this._activeRequestUrls$.value.filter((u) => u !== url);
    this._activeRequestUrls$.next(update);
  }
}
